export const ADMIN = 'ADMIN';
export const MANAGER = 'MANAGER';
export const FIELD_STAFF = 'FIELD_STAFF';
export const ASSISTANT_MANAGER = 'ASSISTANT_MANAGER';
export const PAYROLL = 'PAYROLL';
export const SUPERVISOR = 'SUPERVISOR';
